// try to keep this to sizes only, not margins/paddings etc
export enum IconSizeClasses {
    ExtraLarge = "h-24 w-24",
    Large = "h-8 w-8",
    Medium = "h-6 w-6",
    MediumSmall = "h-5 w-5",
    Small = "h-4 w-4",
    ExtraSmall = "h-3 w-3",
    ExtremelySmall = "h-2 w-2",
    Fit = "h-fit w-fit",
}

// heroicons take their color cue from the text-* class, so here we standardize our system colors
// https://tailwindcss.com/docs/text-color
export enum IconColorClasses {
    Green = "text-green-400",
    Blue = "text-blue-300",
    White = "text-white",
    Black = "text-black",
}

// the one place where all map control icons should get their sizes from
export enum MapControlIconSizeClasses {
    Regular = "map-control-square-regular",
    Small = "h-10 w-10",
    ExtraSmall = "h-7 w-7",
}
